<template>
  <div
    class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;"
  >
    <div class="vue-template">
      <form>
        <h3>Регистрация</h3>
        <div class="form-group">
          <label>{{ $t("Телефон номер") }}</label>
          <input
            type="text"
            ref="focused"
            v-model="phone"
            class="form-control form-control-lg"
          />
          <!-- <label>{{$t('Номи')}}</label>
          <input
            type="text"
            v-model="fullname"
            class="form-control form-control-lg"
          />
          <label>Смс қод</label>
          <input
            type="text"
            v-model="sms_code"
            class="form-control form-control-lg"
          />-->
        </div>

        <button
          type="button"
          class="btn btn-dark btn-lg btn-block"
          @click="Sendsms()"
        >
          {{ $t("Сақлаш") }}
        </button>
        <!-- <p class="forgot-password text-right mt-2 mb-4"></p> -->
        <div class="end">
          <router-link :to="{ path: '/sendsms' }" style="color: blue!important;">
            {{ $t("ИД Ўзгартириш") }}
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.vue-template form {
  padding: 2% 8%;
  border-radius: 10px;
  background: white;
}

.vs__selected-options {
  max-width: 100% !important;
}
</style>

<script>
export default {
  data() {
    return {
      data: [],
      phone:'+998',
      fullname:'',
      sms_code:'',
      hostname:'',
      ipservermobile:"",
      type:'client'
    };
  },
  created(){
    let self=this;
    axios
        .get("http://localhost:3001/api/v1/registration/get-hostname")
        .then(function(response) {
          self.hostname=response.data;
          self.type='baza';
        }).catch(function (error) {
            if (error.request) {
              self.$store.state.errors='';
            } 
  });
  },
  methods: {
    Focus() {
      this.$refs.focused.focus();
    },
    Sendsms() {
        let self = this;
      const username = self.data.username;
      const password = self.data.password;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
      axios({
            method: "post",
            url: self.data.url+"/checkPhone",
            data: { 
              phone: self.phone
            },
            headers: {
            'Authorization': `Basic ${token}`
            }
            },
            ).then(function (response) {
              if(response.data.error==false){
                // console.log(response.data)
                if(response.data.data.old==false){
                  self.$router.push({ path: "/registerbase/"+self.phone });
                }else{
                  self.$store.state.errors=self.$t('Телефон рақам аллақачон рўйхатдан ўтган');
                }
                
                // localStorage.setItem("ip", "http://" + response.data.data.ipaddress + ":3001");
                //     axios.defaults.baseURL="http://" + response.data.data.ipaddress + ":3001"
                // self.$router.push({ name: "Login" });
              }else{
                self.$store.state.errors=response.data.message;
              }
            });
      },
      Registerlocal(secret_code){
        let self=this;
        axios({
            method: "post",
            url: "http://localhost:3001/api/v1/registration/confirm-sms",
            data: { 
              secret_code: secret_code, 
              sms_code: self.sms_code,
              IpServer:self.hostname,
              IpPort:'3001',
              IpServerMobile:self.ipservermobile
            },
            },
            ).then(function (response) {
              if(response.data.error==false){
                localStorage.setItem("ip", "http://" + response.data.data.ipaddress + ":3001");
                    axios.defaults.baseURL="http://" + response.data.data.ipaddress + ":3001"
                self.$router.push({ name: "Login" });
              }else{
                self.$store.state.errors=response.data.message;
              }
            });
      },
      Send() {
        let self = this;
      const username = self.data.username;
      const password = self.data.password;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
      axios({
            method: "post",
            url: self.data.url+"/AutoRegistration",
            data: { 
              phone: self.phone,
              fullname:self.fullname,
              sms_code:self.sms_code
            },
            headers: {
            'Authorization': `Basic ${token}`
            }
            },
            ).then(function (response) {
              if(response.data.error==false){
                self.Registerlocal(response.data.data.secret_code);
                // localStorage.setItem("ip", "http://" + response.data.data.ipaddress + ":3001");
                // axios.defaults.baseURL="http://" + response.data.data.ipaddress + ":3001"
                // self.$router.push({ name: "Login" });
              }else{
                self.$store.state.errors=response.data.message;
              }
            });
      }  
  },
  mounted() {
    let self=this;
    axios
        .get("http://bdm.uz/server/url")
        .then(function(response) {
          self.data = response.data;
        });
        axios
        .get("http://localhost:3001/api/v1/registration/get-ip-address")
        .then(function(response) {
          var obj=Object.keys(response.data);
          
          obj.forEach(element => {
            self.ipservermobile=response.data[element][0];
          });
        });
    self.Focus();
  }
};
</script>
